'use strict';
import React, { PureComponent } from 'react';
import ReemplazarModelosContables from './ReemplazarModelosContables';
import BuscadorCuentasContables from '../../../Common/BuscadorCuentasContables';


class ModalReemplazarCuentasContables extends PureComponent {
    constructor(props) {
        super(props);

        this.cambiarEstadoCheckABMModelos = this.cambiarEstadoCheckABMModelos.bind(this);
    }

    cambiarEstadoCheckABMModelos(nombreCheck, valor) {
        this.props.cambiarEstadoCheckABMModelos("modalReemplazarCuentasContables", nombreCheck, valor);
    }

    render() {
        const {
            checkReemplazarEnOtrosModelos,
            cuentasContablesReemplazarCon,
            cuentasContablesReemplazarCuenta,
            cuentasSeleccionadas,
            errorValidacion,
            esEdicion,
            inputActivo,
            inputsBuscador,
            inputModelos,
            modeloEdicion,
            modelosContablesFiltrados,
            modelosSeleccionados,
            mostrarSpinnerModales,
            mostrarVerMas
        } = this.props;

        //ACTIONS
        const { 
            buscarCuentasContables,
            buscarModelosModalReemplazarCuentasContables,
            cambiarCuentasContables,
            cambiarInputActivo,
            cambiarInputBuscadorModelosActivo,
            guardarQuitarModeloSeleccionado,
            guardarValorInput,
            mostrarOcultarModalReemplazarCuentasContables,
            ocultarBotonVerMas
        } = this.props;

        let inputCuentaContableHabilitado = Boolean(cuentasSeleccionadas.inputReemplazarCuenta);
        let inputBuscadorModelosHabilitado = Boolean(cuentasSeleccionadas.inputReemplazarCon);

        let claseInputReemplazarCuenta = inputCuentaContableHabilitado ? " ABMModelos__buscadorCuentasContables--valorSeleccionado" : "";
        let claseInputReemplazarCon = inputBuscadorModelosHabilitado ? " ABMModelos__buscadorCuentasContables--valorSeleccionado" : "";

        let clasecheckboxInhabilitado = inputBuscadorModelosHabilitado && esEdicion ? "" : " ABMModelos__checkboxBuscadorModelos--deshabilitado";

        let botonAceptarHabilitado = checkReemplazarEnOtrosModelos ? modelosSeleccionados?.length > 0 && (inputCuentaContableHabilitado && inputBuscadorModelosHabilitado) : (inputCuentaContableHabilitado && inputBuscadorModelosHabilitado);

        return (
            <div className="modalContainer ABMModelos-widthModalReemplazarCuentas">
                {mostrarSpinnerModales ?
                    <div id="loading" className="loading" />
                :
                    null
                }

                <div className="ABMModelosModalContainer ABMModelos-widthModalReemplazarCuentas">
                    <div className="ABMModelosModalContainer__header">
                        <div className="ABMModelosModalContainer__contenedorTituloBoton">
                            <div className="ABMModelosModalContainer__titulo">Reemplazar cuentas contables</div>
                            <div className="ABMModelosModalContainer__botonCerrar" onClick={() => mostrarOcultarModalReemplazarCuentasContables("modalReemplazarCuentasContables", false)}></div>
                        </div>
                        <div className="ABMModelosModalContainer__modalAltaEdicionRenglonContable__lineaDivisoria ABMModelosModalContainer__modalAltaEdicionRenglonContable__lineaDivisoriaHeader ABMModelosModalContainer__modalReemplazarCuentasContables__lineaDivisoria"></div>
                    </div>


                    <div className="ABMModelosModalContainer__body">
                        <div className="ABMModelosModalContainer__contenedorBuscadores">
                            <div className="seccionDatosGenerales__tituloSecundario">Reemplazar la cuenta contable</div>

                            <BuscadorCuentasContables 
                                buscarCuentasContables={buscarCuentasContables}
                                cambiarInputActivo={cambiarInputActivo}
                                cuentasContables={cuentasContablesReemplazarCuenta}
                                estaHabilitado={true}
                                estiloPlaceholder={""}
                                guardarValorInput={guardarValorInput}
                                inputActivo={inputActivo}
                                inputClassValorSeleccionado={claseInputReemplazarCuenta}
                                nombreInput={"inputReemplazarCuenta"}
                                seccionInput={"modalReemplazarCuentasContables"}
                                valorInput={inputsBuscador.inputReemplazarCuenta}
                            />
                        </div>


                        <div className="ABMModelosModalContainer__contenedorBuscadores">
                            <div className={"seccionDatosGenerales__tituloSecundario" + (inputCuentaContableHabilitado ? "" : " ABMModelos__buscadorCuentasContables--deshabilitado")}>por la cuenta contable</div>
                            
                            <BuscadorCuentasContables
                                buscarCuentasContables={buscarCuentasContables}
                                cambiarInputActivo={cambiarInputActivo}
                                cuentasContables={cuentasContablesReemplazarCon}
                                estaHabilitado={inputCuentaContableHabilitado}
                                estiloPlaceholder={inputCuentaContableHabilitado ? "" : " ABMModelos__buscadorCuentasContables--deshabilitado"}
                                guardarValorInput={guardarValorInput}
                                inputActivo={inputActivo}
                                inputClassValorSeleccionado={claseInputReemplazarCon}
                                nombreInput={"inputReemplazarCon"}
                                seccionInput={"modalReemplazarCuentasContables"}
                                valorInput={inputsBuscador.inputReemplazarCon}
                            />
                        </div>


                        <div className="ABMModelosModalContainer__contenedorCheckReemplazarOtrosModelos">
                            <div className="Tarjetas-contenedorCheckboxActivo default-checkbox Tarjetas-default-checkbox">
                                <input disabled={false} type="checkbox" id={"ReemplazarEnOtrosModelos"} checked={checkReemplazarEnOtrosModelos} onChange={() => clasecheckboxInhabilitado ? null : this.cambiarEstadoCheckABMModelos("checkReemplazarEnOtrosModelos", !checkReemplazarEnOtrosModelos)}/>
                                <label className={"label-primary Tarjetas-checkboxLabel" + (checkReemplazarEnOtrosModelos ? clasecheckboxInhabilitado ? " Tarjetas-checkboxLabel--checked-disabled" : " Tarjetas-checkboxLabel--checked" : "") + clasecheckboxInhabilitado} htmlFor={"ReemplazarEnOtrosModelos"}></label>
                            </div>
                            <label className={"label-primary seccionDatosGenerales__label seccionDatosGenerales__checkboxLabelHabilitado ABMModelosModalContainer__labelReemplazarOtrosModelos" + (inputBuscadorModelosHabilitado && !clasecheckboxInhabilitado ? "" : " ABMModelos__buscadorCuentasContables--deshabilitado")}>Reemplazar también en otros modelos</label>
                        </div>


                        {checkReemplazarEnOtrosModelos ?
                            <ReemplazarModelosContables
                                buscarModelosModalReemplazarCuentasContables={buscarModelosModalReemplazarCuentasContables}
                                
                                cambiarInputBuscadorModelosActivo={cambiarInputBuscadorModelosActivo}
                                guardarQuitarModeloSeleccionado={guardarQuitarModeloSeleccionado}
                                inputActivo={inputActivo}
                                inputModelos={inputModelos}
                                modeloEdicion={modeloEdicion}
                                modelosContablesFiltrados={modelosContablesFiltrados}
                                modelosSeleccionados={modelosSeleccionados}
                                mostrarVerMas={mostrarVerMas}
                                nombreInput={"inputModelos"}
                                seccionInput={"modalReemplazarCuentasContables"}
                                ocultarBotonVerMas={ocultarBotonVerMas}
                            />
                        :
                            null
                        }

                        {errorValidacion.modalReemplazarCuentasContables ? 
                            <div>
                                <label className="genericLabel errorMessage ABMModelos__widhtErrorMessage">{errorValidacion.modalReemplazarCuentasContables}</label>
                            </div>
                        :
                            null
                        }
                    </div>

                    <div className="ABMModelosModalContainer__footer">
                        <div>
                            <button className={"ABMModelosModalContainer__botonAceptar" + (botonAceptarHabilitado ? "" : " ABMModelosModalContainer__botonAceptar--deshabilitado")} onClick={() => botonAceptarHabilitado ? cambiarCuentasContables(cuentasSeleccionadas.inputReemplazarCuenta, cuentasSeleccionadas.inputReemplazarCon) : null}>
                                Aceptar
                            </button>
                        </div>
                    

                        <div>
                            <button className="ABMModelosModalContainer__botonCancelar" onClick={() => mostrarOcultarModalReemplazarCuentasContables("modalReemplazarCuentasContables", false)}>
                                Cancelar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ModalReemplazarCuentasContables;